module.exports = __webpack_public_path__ + "static/media/astuce.0156a1dd.png";